import ActionTypes from "../constants/action_types";

export default function userSetUnauthorized() {
  return {
    type: ActionTypes.USER_SET_UNAUTHORIZED.SUCCESS,
  };
}
